module.exports = __webpack_public_path__ + "afc53a7af198f0f71b4c03db0891e7c1.pdf";